var _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCirrus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 33,
    viewBox: "0 0 46 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 45,
    height: 31,
    rx: 3.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 45,
    height: 31,
    rx: 3.5,
    stroke: "#FFFFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6768 16.1077C25.6768 21.0456 21.7197 25.0487 16.8384 25.0487C11.9571 25.0487 8 21.0456 8 16.1077C8 11.1697 11.9571 7.16666 16.8384 7.16666C21.7197 7.16666 25.6768 11.1697 25.6768 16.1077Z",
    fill: "#0066BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1429 16.1077C37.1429 21.0456 33.1858 25.0487 28.3045 25.0487C23.4232 25.0487 19.4661 21.0456 19.4661 16.1077C19.4661 11.1697 23.4232 7.16666 28.3045 7.16666C33.1858 7.16666 37.1429 11.1697 37.1429 16.1077Z",
    fill: "#00A2E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5713 22.913C24.4718 21.2731 25.6768 18.8328 25.6768 16.1078C25.6768 13.3828 24.4718 10.9425 22.5713 9.30258C20.6709 10.9425 19.4658 13.3828 19.4658 16.1078C19.4658 18.8328 20.6709 21.2731 22.5713 22.913Z",
    fill: "#6C6BBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirrus);
export default __webpack_public_path__ + "static/media/cirrus.b2420e0e56060bb5d3c60a7160baa98d.svg";
export { ForwardRef as ReactComponent };